import React from "react";
import { Chip, Divider, Box, Tooltip } from "@mui/material";
import {
	WarningAmberRounded,
	ErrorOutlineRounded,
	PriorityHighRounded,
	InfoOutlined,
	ReportOutlined,
} from "@mui/icons-material";

const SeverityChip = ({ severity, theme }) => {
	const chipStyles = {};
	const chipMessege = {
		5: "Desastre",
		4: "Alta",
		3: "Média",
		2: "Atenção",
		1: "Informação",
		0: "Não classificado",
	};

	switch (severity) {
		case "5":
			Object.assign(chipStyles, {
				backgroundColor: theme.palette.chip.background.critical,
				color: theme.palette.chip.colorText.critical,
				border: "0.1px solid ",
				borderColor:
					theme.palette.mode === "dark"
						? theme.palette.colors.red.darker
						: theme.palette.colors.red.light,
				borderRadius: "10px",
				height: "20px",
				width: "105px",
			});
			break;
		case "4":
			Object.assign(chipStyles, {
				backgroundColor: theme.palette.chip.background.high,
				color: theme.palette.chip.colorText.high,
				border: "0.6px solid ",
				borderColor: theme.palette.colors.orange.medium,
				borderRadius: "10px",
				height: "20px",
				width: "105px",
			});
			break;
		case "3":
			Object.assign(chipStyles, {
				backgroundColor: theme.palette.chip.background.low,
				color: theme.palette.chip.colorText.low,
				border: "0.6px solid ",
				borderColor: theme.palette.chip.colorText.low,
				borderRadius: "10px",
				height: "20px",
				width: "105px",
			});
			break;
		case "2":
			Object.assign(chipStyles, {
				backgroundColor: theme.palette.chip.background.medium,
				color: theme.palette.chip.colorText.medium,
				border: "0.6px solid ",
				borderColor: theme.palette.chip.colorText.medium,
				borderRadius: "10px",
				height: "20px",
				width: "105px",
			});
			break;
		case "1":
			Object.assign(chipStyles, {
				border: "0.6px solid ",
				borderRadius: "10px",
				height: "20px",
				width: "105px",
			});
			break;
		default:
			Object.assign(chipStyles, {
				backgroundColor: theme.palette.chip.background.default,
				color: theme.palette.chip.colorText.default,
				height: "20px",
			});
	}

	const renderIcon = () => {
		switch (severity) {
			case "5":
				return (
					<WarningAmberRounded
						fontSize="small"
						sx={{ fill: theme.palette.chip.colorText.critical }}
					/>
				);
			case "4":
				return (
					<ErrorOutlineRounded
						fontSize="small"
						sx={{ fill: theme.palette.chip.colorText.high }}
					/>
				);
			case "3":
				return (
					<ReportOutlined
						fontSize="small"
						sx={{ fill: theme.palette.chip.colorText.low }}
					/>
				);
			case "2":
				return (
					<PriorityHighRounded
						fontSize="small"
						sx={{ fill: theme.palette.chip.colorText.medium }}
					/>
				);
			case "1":
				return <InfoOutlined fontSize="small" />;
			default:
				return null;
		}
	};

	return (
		<Tooltip title={chipMessege[severity]} arrow>
			<Chip
				label={
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							gap: severity == 4 ? "12px" : "4px",
							fontWeight: 500,
						}}
					>
						{renderIcon()}
						{chipMessege[severity]}
					</Box>
				}
				sx={{
					...chipStyles,
					display: "flex",
					justifyContent: "flex-start",
					gap: "10px",
				}}
				size="small"
			/>
		</Tooltip>
	);
};

export default SeverityChip;
